module.exports = __webpack_public_path__ + "img/pikachu-female.779e274f.gif";